const Plus = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g fill="#94A8BE" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm4 11h-3v3c0 .6-.4 1-1 1s-1-.4-1-1v-3H6c-.6 0-1-.4-1-1s.4-1 1-1h3V6c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1z"
                transform="translate(-812 -551) translate(737 537) translate(75 14)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export { Plus };
